/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Status_UpcomingInputs */

const en_admin_resources_resource_allocations_status_upcoming = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const de_admin_resources_resource_allocations_status_upcoming = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anstehend`)
};

const es_admin_resources_resource_allocations_status_upcoming = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximas`)
};

const fr_admin_resources_resource_allocations_status_upcoming = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_status_upcoming = en_admin_resources_resource_allocations_status_upcoming;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_status_upcoming = en_admin_resources_resource_allocations_status_upcoming;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_status_upcoming = en_admin_resources_resource_allocations_status_upcoming;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_status_upcoming = en_admin_resources_resource_allocations_status_upcoming;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_UpcomingInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_status_upcoming = en_admin_resources_resource_allocations_status_upcoming;

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Admin_Resources_Resource_Allocations_Status_UpcomingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_status_upcoming = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Status_UpcomingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Status_UpcomingInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_status_upcoming(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_status_upcoming(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_status_upcoming(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_status_upcoming(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_status_upcoming(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_status_upcoming(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_status_upcoming(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_status_upcoming(inputs)
	return ro_admin_resources_resource_allocations_status_upcoming(inputs)
});
export { admin_resources_resource_allocations_status_upcoming as "admin.resources.resource_allocations.status_upcoming" }